import { isWeb } from "../utilities/platform";
import { Platform } from "./options";

export const isBuild = process.env.NODE_ENV === "production";
export const isProduction = isBuild && process.env.GATSBY_BUILD_PROD === "true"; 
export const isDemo = isBuild && process.env.GATSBY_BUILD_STAGING === "true";
// export const isDemo = "true";
export const isBuildingOnDevice = isBuild && !isDemo && !isProduction;  // WHEN STEVE BUILDS ON HIS OWN COMPUTER

const BackendUrl = {
  DEMO: 'https://demo-practitioner-api.healthnex.com.au',
  PRODUCTION: 'https://practitionerapi.healthnex.com.au',
  LOCAL_248: 'http://192.168.0.151:5193',
  JUNE: 'http://192.168.0.108:5193',
  LOCALHOST: 'http://localhost:5193',
  TEMP: 'http://172.20.10.6:5193',
}

// Build Name: dev-vai-practitioner-2025-10-24
// Production FE: https://practitioner.healthnex.com.au
// Demo FE: https://demo-public.healthnex.com.au

// const IsBuilding4Production = false;
// const IsBuilding4Dev = !isProduction;

const LocalBuildKey: 'DEMO' | 'PRODUCTION' = 'DEMO'; // 'DEMO' or 'PRODUCTION' use with isBuildingOnDevice only

const MemberUrls = {
  DEMO: 'https://demo-public.healthnex.com.au',
  PRODUCTION: 'https://healthnex.com.au',
};

export const BaseMemberUrl = isDemo ? MemberUrls.DEMO :
  isProduction ? MemberUrls.PRODUCTION :
    isBuildingOnDevice ? MemberUrls[LocalBuildKey] :             // FOR WHEN STEVE IS BUILDING LOCALLY
      MemberUrls.DEMO;                                           // FOR DEVELOPMENT

export const backEndBaseURL = isDemo ? BackendUrl.DEMO :
  isProduction ? BackendUrl.PRODUCTION :
    isBuildingOnDevice ? BackendUrl[LocalBuildKey] :                        // FO WHEN STEVE IS BUILDING LOCALLY
      BackendUrl.LOCAL_248;                                      // FOR DEVELOPMENT

const SQUARE_SANDBOX_ID = "sandbox-sq0idb-7wkiUlmjTmYIXmjkpTv9ww";
// const SQUARE_SANDBOX_ID = "sq0idp-gxIjm6fNU1jd5oAiojnUYw";
const SQUARE_PRODUCTION_ID = "sq0idp-gxIjm6fNU1jd5oAiojnUYw";

const SquareId = {
  DEMO: SQUARE_SANDBOX_ID,
  PRODUCTION: SQUARE_PRODUCTION_ID,
};

export const SQUARE_APPLICATION_ID = isDemo ? SquareId.DEMO :
  isProduction ? SquareId.PRODUCTION :
    isBuildingOnDevice ? SquareId[LocalBuildKey] :              // FOR WHEN STEVE IS BUILDING LOCALLY
      SquareId.DEMO;                                            // FOR DEVELOPMENT

export const FrontBaseEndUrl = isWeb ? window.location.origin : "";

// export const backEndBaseURL = isProduction ? prodBackEndUrl : devBackEndUrl;
//export const aiVoiceBackendUrl = isProduction ? prodAiVoiceBackendUrl : "https://106b-120-150-254-137.ngrok-free.app"; // 'http://192.168.15.252:45467/';

const CommunityUrls = {
  DEMO: 'https://demo-community.healthnex.com.au/profile',
  PRODUCTION: 'https://community.healthnex.com.au/profile',
};

export const communityUrl = isProduction ? CommunityUrls.PRODUCTION :
  isDemo ? CommunityUrls.DEMO :
    isBuildingOnDevice ? CommunityUrls[LocalBuildKey] :   // FOR WHEN STEVE IS BUILDING LOCALLY
      CommunityUrls.PRODUCTION;                           // FOR DEVELOPMENT  

export const encryptedPassword = "*ENCRYPTEDPASSWORD*";
export const aiVoiceCategory = "clinic";

export const VERSION_NO = "1.3.2";

export const CURRENT_PLATFORM = Platform.PRACTITIONER;

// export const ELEVEN_LABS_API_KEY = "sk_0e789f7c098ac9efad1bbd4fa63273a6f89f64ee48c5a04b";
// export const ELEVEN_LABS_API_KEY = "sk_e5d6ceb4948c884d26897d8bc0427ec10538b94d73a0584f";



//PAGE CONFIG

export const VIP_SHOW = true;
// export const COUNT_AI_TOKEN = isDevelopment;

export const DEFAULT_NEED_SUMMARY = true;
export const DEFAULT_LANDING_PAGE = "/prescription";
export const RESET_PRICE_ON_EDIT_TREATMENT = true;
export const FILE_MAX_COUNT = 10;
export const PAYMENT_FILES_UPLOAD_LIMIT = 4;
export const SHOW_NAV_WEB = true;
// UI PHASE: when true (or when visiting /sign-up?ui=new), the sign-up route renders
// the new onboarding flow instead of the legacy form (self sign-up / invite / join
// clinic paths). CMASA org-token sign-ups (?token=...) always fall through to the
// legacy form regardless of this flag — see sign-up.tsx's isOrgTokenSignUp check.
// The legacy sign-up implementation is fully preserved and reachable via that path.
export const SHOW_NEW_ONBOARDING_UI = true;
export const USE_REALTIME_SCRIBE = false;
export const ENABLE_AUTO_RECHARGE = true;
export const SHOW_PREGNANCY = true;
// Released — the refund button/flow (HicapsRefundNotice/HicapsRefundDialog)
// is now visible. Terminal calls within it are still separately gated by
// HICAPS_REFUND_TERMINAL_CALLS_ENABLED below.
export const HICAPS_REFUND_ENABLED = true;
// Temporarily off — when the refund flow above does get exercised (e.g. by
// flipping HICAPS_REFUND_ENABLED back on for testing), the ClaimCancel/
// TransactionRefund terminal calls are skipped entirely and each step just
// auto-advances; only prescriptionStore's own APIs (markInsuranceRebateAsPaid,
// refundPayment) are actually called. Flip back to true once the terminal
// side is ready to be exercised again.
export const HICAPS_REFUND_TERMINAL_CALLS_ENABLED = false;

export const CUSTOMER_SERVICE_PHONE = "02 9315 8870";
export const TECHNICAL_SUPPORT_PHONE = "0415 094993";

// Format is <terminalIp>:<port>:<terminalCode>:<connectionType> — confirmed
// against a real terminal response, not a bare IP.
export const HICAPS_TERMINAL_SERVER_URL = "192.168.0.248:11002:SE313A:COMT";
export const HICAPS_TERMINAL_HUB_URL = "http://192.168.0.108:51213/healthnex";
// Hardcoded for now — remove once merchant ID has a real source (e.g. a
// clinic setting) instead of a single fixed value for all clinics.
export const HICAPS_MERCHANT_ID = "30200026";